/** Окно VIP — подключение к стору и колбэкам. */
import type { OfferPlace } from "@newfungame/contracts";
import type { WindowProps } from "../kit";
import { VipView } from "./view";
import { appStore, useStore, vipActive, registerWindow } from "../../../app";
import { actions } from "../actions";
import { useBuy } from "../offers";
import { useEffect } from "preact/hooks";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    vip: { place: OfferPlace };
  }
}

export function Vip({ route, close }: WindowProps<"vip">) {
  const canPay = useStore(appStore, (s) => s.miniApp);
  const vip = useStore(appStore, vipActive);
  const stars = useStore(appStore, (s) => s.player?.prices.vip);
  const { busy, buy } = useBuy(route.place);
  useEffect(() => actions().offerShown(route.place), []);
  useEffect(() => {
    if (vip) close();
  }, [vip]);
  return (
    <VipView
      stars={stars}
      canPay={canPay}
      busy={busy}
      onBuy={() => buy("vip")}
      onTelegram={() => actions().openTelegram(route.place)}
      onClose={close}
    />
  );
}

export function register(): void {
  registerWindow("vip", Vip);
}
